module.exports = __webpack_public_path__ + "static/img/product-swipe21.79efde1a.png";